module.exports = __webpack_public_path__ + "img/service_img7.68ce3123.png";